import { render, staticRenderFns } from "./PanelForm.vue?vue&type=template&id=231c0b3c&scoped=true"
import script from "./PanelForm.vue?vue&type=script&lang=js"
export * from "./PanelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c0b3c",
  null
  
)

export default component.exports